<template>
  <div class="qr-code-container">
    <h2>{{ $t('qrCode.title') }}</h2>
    <p class="qr-code-description">{{ $t('qrCode.description') }}</p>
    
    <div class="qr-code-display">
      <div class="qr-code">
        <!-- CSS basierter Fallback QR Code -->
        <div class="fallback-qr" v-if="!qrCodeGenerated">
          <div class="fallback-qr-inner">
            <div class="fallback-qr-position">
              <div class="fallback-qr-box"></div>
            </div>
          </div>
        </div>
        <div ref="qrCodeElement" class="dynamic-qr-code"></div>
      </div>
      <div class="qr-url">{{ fullUploadUrl }}</div>
    </div>
    
    <div class="qr-actions">
      <button @click="downloadQRCode" class="download-button">
        <i class="fas fa-download"></i> {{ $t('qrCode.download') }}
      </button>
      <button @click="printQRCode" class="print-button">
        <i class="fas fa-print"></i> {{ $t('qrCode.print') }}
      </button>
    </div>
    
    <div class="usage-tips">
      <h3>{{ $t('qrCode.usageTips') }}</h3>
      <ul>
        <li>{{ $t('qrCode.tip1') }}</li>
        <li>{{ $t('qrCode.tip2') }}</li>
        <li>{{ $t('qrCode.tip3') }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode'

export default {
  name: 'FanPhotoQRCode',
  data() {
    return {
      baseUrl: window.location.origin,
      uploadPath: '/fan-upload',
      qrCodeGenerated: false,
      error: null
    }
  },
  computed: {
    fullUploadUrl() {
      return `${this.baseUrl}${this.uploadPath}`
    }
  },
  mounted() {
    // Verzögerter Aufruf, um sicherzustellen, dass das DOM vollständig geladen ist
    this.$nextTick(() => {
      setTimeout(() => {
        this.generateQRCode();
      }, 300);
    });
  },
  methods: {
    generateQRCode() {
      try {
        // QR-Code mit Hilfe der Bibliothek generieren
        const options = {
          errorCorrectionLevel: 'H',
          margin: 4,
          scale: 8,
          color: {
            dark: '#000000',
            light: '#ffffff'
          }
        };
        
        QRCode.toDataURL(this.fullUploadUrl, options, (error, url) => {
          if (error) {
            console.error('QR-Code-Generierungsfehler:', error);
            this.error = error;
            return;
          }
          
          // QR-Code als Bild anzeigen
          const img = new Image();
          img.src = url;
          img.alt = "QR-Code für Fan-Fotos";
          img.style.maxWidth = "100%";
          img.style.height = "auto";
          
          if (this.$refs.qrCodeElement) {
            this.$refs.qrCodeElement.innerHTML = '';
            this.$refs.qrCodeElement.appendChild(img);
            this.qrCodeGenerated = true;
          }
        });
      } catch (err) {
        console.error('Fehler bei der QR-Code-Generierung:', err);
        this.error = err;
      }
    },
    
    downloadQRCode() {
      try {
        // Wenn dynamischer QR-Code generiert wurde, diesen verwenden
        if (this.qrCodeGenerated && this.$refs.qrCodeElement) {
          const img = this.$refs.qrCodeElement.querySelector('img');
          if (img && img.src) {
            const link = document.createElement('a');
            link.href = img.src;
            link.download = 'homeward-fanfotos-qrcode.png';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            return;
          }
        }
        
        // Alternativ neuen QR-Code generieren
        QRCode.toDataURL(this.fullUploadUrl, { errorCorrectionLevel: 'H' }, (error, url) => {
          if (error) {
            alert('QR-Code konnte nicht generiert werden. Bitte versuchen Sie es später erneut.');
            return;
          }
          
          const link = document.createElement('a');
          link.href = url;
          link.download = 'homeward-fanfotos-qrcode.png';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        });
      } catch (err) {
        console.error('Fehler beim Herunterladen des QR-Codes:', err);
        alert('Beim Herunterladen des QR-Codes ist ein Fehler aufgetreten.');
      }
    },
    
    printQRCode() {
      try {
        const printQrCode = (imageUrl) => {
          const printWindow = window.open('', '_blank');
          printWindow.document.write(`
            <html>
              <head>
                <title>${this.$t('qrCode.printTitle')}</title>
                <style>
                  body {
                    font-family: Arial, sans-serif;
                    text-align: center;
                    padding: 20px;
                  }
                  .qr-container {
                    margin: 0 auto;
                    max-width: 500px;
                  }
                  h1 {
                    font-size: 24px;
                    margin-bottom: 10px;
                  }
                  p {
                    font-size: 16px;
                    margin-bottom: 20px;
                  }
                  img {
                    max-width: 100%;
                    height: auto;
                  }
                  .url {
                    margin-top: 15px;
                    font-size: 14px;
                    word-break: break-all;
                  }
                  @media print {
                    @page {
                      size: auto;
                      margin: 10mm;
                    }
                  }
                </style>
              </head>
              <body>
                <div class="qr-container">
                  <h1>${this.$t('qrCode.printHeading')}</h1>
                  <p>${this.$t('qrCode.printDescription')}</p>
                  <img src="${imageUrl}" alt="QR Code" />
                  <div class="url">${this.fullUploadUrl}</div>
                </div>
                <script>
                  window.onload = function() {
                    setTimeout(function() {
                      window.print();
                    }, 500);
                  };
                <\/script>
              </body>
            </html>
          `);
          printWindow.document.close();
        };
        
        // Wenn dynamischer QR-Code generiert wurde, diesen verwenden
        if (this.qrCodeGenerated && this.$refs.qrCodeElement) {
          const img = this.$refs.qrCodeElement.querySelector('img');
          if (img && img.src) {
            printQrCode(img.src);
            return;
          }
        }
        
        // Alternativ neuen QR-Code generieren
        QRCode.toDataURL(this.fullUploadUrl, { errorCorrectionLevel: 'H' }, (error, url) => {
          if (error) {
            alert('QR-Code konnte nicht generiert werden. Bitte versuchen Sie es später erneut.');
            return;
          }
          
          printQrCode(url);
        });
      } catch (err) {
        console.error('Fehler beim Drucken des QR-Codes:', err);
        alert('Beim Drucken des QR-Codes ist ein Fehler aufgetreten.');
      }
    }
  }
}
</script>

<style scoped>
.qr-code-container {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
  font-family: 'Open Sans', sans-serif;
}

h2 {
  text-align: center;
  margin-bottom: 15px;
  color: #333;
}

.qr-code-description {
  text-align: center;
  margin-bottom: 30px;
  line-height: 1.6;
  color: #555;
}

.qr-code-display {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f8f8f8;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  margin-bottom: 25px;
}

.qr-code {
  margin-bottom: 15px;
  min-height: 200px;
  min-width: 200px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dynamic-qr-code {
  z-index: 2;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* CSS-basierter QR-Code-Fallback */
.fallback-qr {
  width: 200px;
  height: 200px;
  background-color: white;
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
}

.fallback-qr-inner {
  width: 100%;
  height: 100%;
  background-color: white;
  position: relative;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-template-rows: repeat(7, 1fr);
  gap: 2px;
}

.fallback-qr-inner::before, 
.fallback-qr-inner::after,
.fallback-qr-position::before {
  content: "";
  position: absolute;
  width: 30%;
  height: 30%;
  background-color: black;
  border: 8px solid white;
  box-sizing: border-box;
}

.fallback-qr-inner::before {
  top: 0;
  left: 0;
}

.fallback-qr-inner::after {
  top: 0;
  right: 0;
}

.fallback-qr-position::before {
  bottom: 0;
  left: 0;
}

.fallback-qr-box {
  background-color: black;
  width: 100%;
  height: 100%;
  grid-column: span 3;
  grid-row: span 3;
}

.qr-url {
  font-size: 14px;
  color: #666;
  word-break: break-all;
  text-align: center;
  margin-top: 10px;
}

.qr-actions {
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-bottom: 30px;
}

.download-button, .print-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border: none;
  border-radius: 4px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s;
}

.download-button {
  background-color: #4caf50;
  color: white;
}

.download-button:hover {
  background-color: #3e8e41;
}

.print-button {
  background-color: #2196f3;
  color: white;
}

.print-button:hover {
  background-color: #0b7dda;
}

.usage-tips {
  background-color: #fffde7;
  padding: 20px;
  border-radius: 8px;
  border-left: 4px solid #fbc02d;
}

.usage-tips h3 {
  margin-top: 0;
  margin-bottom: 15px;
  color: #333;
  font-size: 18px;
}

.usage-tips ul {
  margin: 0;
  padding-left: 20px;
}

.usage-tips li {
  margin-bottom: 10px;
  line-height: 1.5;
  color: #555;
}

.usage-tips li:last-child {
  margin-bottom: 0;
}

@media (max-width: 600px) {
  .qr-code-container {
    padding: 15px;
  }
  
  .qr-code-display {
    padding: 20px;
  }
  
  .qr-actions {
    flex-direction: column;
    gap: 10px;
  }
  
  .download-button, .print-button {
    width: 100%;
    justify-content: center;
  }
}
</style> 